// extracted by mini-css-extract-plugin
module.exports = {"container":"IntroCard_container__1kVLl","connectAccountBtn":"IntroCard_connectAccountBtn__2ohmX","checkbox_root":"IntroCard_checkbox_root__36ib0","text":"IntroCard_text__a7VP6"};